module.exports = __webpack_public_path__ + "img/bottomCTA-bg.df4c92f3.svg";